import { combineReducers } from 'redux';

import { requestStateReducers } from '@weave/design-system';

export default combineReducers({
  ...requestStateReducers,
});
